import React from 'react'
import styled from 'styled-components';
import Header from '../components/Header/Header';

const Contact = () => {
    return (
        <Gallery>
            <Header />
            <Abt>
                <Parent>
                    <Child>
                        <h1>Contact me <br />I am never too busy to talk on some amazing ideas</h1>
                    </Child>
                    <Child>
                        <a href="mailto: mukulrajpoot262610@gmail.com"><i class="fas fa-envelope"></i></a>
                        <a href="https://www.linkedin.com/in/mukul-rajpoot-262610/"><i class="fab fa-linkedin-in"></i></a>
                    </Child>
                </Parent>
            </Abt>
        </Gallery>
    )
}

const Gallery = styled.div`
    min-height: 100vh;
    width: 100%;
    background-color: #fff;
`;

const Abt = styled.div`
    position: relative;
    width: 100%;
    min-height: 100vh;
    padding-top: 10vh;
`;

const Parent = styled.section`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    min-height: 60vh;
    padding: 2rem 0;
    width: 1280px;
    margin: 0 auto;

    & > h1 {
        font-size: 3rem;
        margin: 2rem 0;
        max-width: 50%;
        text-align: center;
    }

    & > a {
        text-decoration: none;
    }

    @media (max-width: 768px) {
        flex-direction: column;
        width: 100%;
    }
`;

const Child = styled.section`
    display: flex;
    align-items: center;
    width: 50%;
    padding: 0 5rem;

    @media (max-width: 768px) {
        width: 100%;
    }

    & > h1 {
        font-size: 4rem;
    }

    & > a {
        font-size: 10rem;
        color: #191919;
        margin-right: 5rem;

        &:hover {
            color: royalblue;
        }
    }
`;


export default Contact
